<script lang="ts">
  export let options: any[];
  export let selectedValue: string | number;
  export let onChange: () => void;
  export let selectId: string;
  export let fontColor: string;
  export let onFocus: () => void = null;
  export let testId: string = null;

</script>

<select
  class="fizz-select fizz-text-strong"
  style="color: {fontColor}"
  id={selectId}
  data-testId={testId}
  name={selectId}
  bind:value={selectedValue}
  on:change={onChange}
  on:blur={() => {}}
  on:focus={onFocus}
>
  {#each options as option}
    <option
      value={option.value || option.id}
      selected={option.value == selectedValue || option.id == selectedValue}
      >{option.name || option.label}</option
    >
  {/each}
</select>
